import ObjectModelActionPermittee from "./objectModelActionPermittee";

export default class ObjectModelActionFormViewer extends ObjectModelActionPermittee {
  get rootName(): string {
    return "object_model_action_form_viewers";
  }
}